const modelName = "Delivery Methods";
const modelNameSingular = "Delivery Method";
const endpoint = "/delivery-methods";

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, "-").toLowerCase(),
  canDelete: true,
  canAddNew: true,
  canSearch: true,
  endpoint,
  accessor: "id",
};

export default setup;
